import React from "react";

const Intervention = ({ className = "madie-icon", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.36105 15.1701C1.30984 15.3174 1.25581 15.4636 1.199 15.6086C1.12 15.8079 1.273 16.0308 1.472 15.9965C1.58923 15.9759 1.7063 15.9543 1.8232 15.9317L1.82831 15.9307C1.9407 15.9089 2.05294 15.8862 2.165 15.8625L2.185 15.8582C2.35865 15.8213 2.52589 15.7833 2.68682 15.7445C2.71925 15.7366 2.75143 15.7288 2.78335 15.7209C4.26217 15.3552 5.19229 14.9239 5.653 14.6742C6.41859 14.893 7.20765 15.0032 8 15.0021C12.418 15.0021 16 11.6437 16 7.50103C16 3.35832 12.418 0 8 0C3.582 0 0 3.35832 0 7.50103C0 9.387 0.743 11.1122 1.97 12.4303C1.90838 13.038 1.80041 13.6389 1.64736 14.2269C1.64043 14.2535 1.6334 14.2801 1.62629 14.3067C1.57162 14.5109 1.51151 14.7135 1.446 14.9142L1.443 14.926C1.41698 15.0063 1.39013 15.0864 1.36245 15.1661L1.36105 15.1701ZM3.28687 13.8184C4.17025 13.5464 4.73179 13.2761 5.01027 13.1252L5.49571 12.8621L6.01691 13.0111C6.66238 13.1956 7.32857 13.2887 7.9981 13.2878L8 13.2878C11.8809 13.2878 14.5 10.3952 14.5 7.50103C14.5 4.60684 11.8809 1.71429 8 1.71429C4.11907 1.71429 1.5 4.60684 1.5 7.50103C1.5 8.84682 2.02631 10.1381 2.99732 11.1812L3.54684 11.7714L3.46003 12.6276C3.41946 13.0277 3.36164 13.4251 3.28687 13.8184Z"
      />
      <path d="M6.5 7.42857C6.5 7.90196 6.16421 8.28572 5.75 8.28572C5.33579 8.28572 5 7.90196 5 7.42857C5 6.95518 5.33579 6.57143 5.75 6.57143C6.16421 6.57143 6.5 6.95518 6.5 7.42857Z" />
      <path d="M9 7.42857C9 7.90196 8.66421 8.28572 8.25 8.28572C7.83579 8.28572 7.5 7.90196 7.5 7.42857C7.5 6.95518 7.83579 6.57143 8.25 6.57143C8.66421 6.57143 9 6.95518 9 7.42857Z" />
      <path d="M11.5 7.42857C11.5 7.90196 11.1642 8.28572 10.75 8.28572C10.3358 8.28572 10 7.90196 10 7.42857C10 6.95518 10.3358 6.57143 10.75 6.57143C11.1642 6.57143 11.5 6.95518 11.5 7.42857Z" />
    </svg>
  );
};
export default Intervention;
